import { createFileRoute } from '@tanstack/react-router';
import { About } from '@/features/content/About';

export const Route = createFileRoute('/_app/about')({ component: About });
